(function() {
  'use strict';

  const toggle = document.querySelector('[data-gi-toggle]');
  if (!toggle) return;

  const buttons = toggle.querySelectorAll('[data-gi-mode]');
  const panels = document.querySelectorAll('[data-gi-panel]');

  function switchMode(mode) {
    buttons.forEach(btn => {
      btn.classList.toggle('aiello-gi-toggle__btn--active', btn.dataset.giMode === mode);
    });
    toggle.dataset.mode = mode;
    panels.forEach(panel => {
      panel.classList.toggle('aiello-gi-passos__panel--active', panel.dataset.giPanel === mode);
    });
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', () => switchMode(btn.dataset.giMode));
  });
})();
